import React, { useState } from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
const SITE_URL = 'https://designflowdigitals.com';
const pages = [{
  path: '/',
  name: 'Home',
  priority: '1.0',
  freq: 'weekly'
}, {
  path: '/about',
  name: 'About Us',
  priority: '0.8',
  freq: 'monthly'
}, {
  path: '/services',
  name: 'Services',
  priority: '0.9',
  freq: 'monthly'
}, {
  path: '/products',
  name: 'Products',
  priority: '0.9',
  freq: 'weekly'
}, {
  path: '/themes',
  name: 'Shopify Themes',
  priority: '0.8',
  freq: 'weekly'
}, {
  path: '/apps',
  name: 'Shopify Apps',
  priority: '0.8',
  freq: 'weekly'
}, {
  path: '/portfolio',
  name: 'Portfolio',
  priority: '0.7',
  freq: 'monthly'
}, {
  path: '/team',
  name: 'Team',
  priority: '0.6',
  freq: 'monthly'
}, {
  path: '/contact',
  name: 'Contact',
  priority: '0.7',
  freq: 'yearly'
}, {
  path: '/flowboost',
  name: 'FlowBoost App',
  priority: '0.8',
  freq: 'monthly'
}, {
  path: '/ai-photoshoot',
  name: 'AI Photoshoot App',
  priority: '0.8',
  freq: 'monthly'
}, {
  path: '/privacy-policy',
  name: 'Privacy Policy',
  priority: '0.3',
  freq: 'yearly'
}, {
  path: '/terms',
  name: 'Terms of Service',
  priority: '0.3',
  freq: 'yearly'
}, {
  path: '/refund-policy',
  name: 'Refund Policy',
  priority: '0.3',
  freq: 'yearly'
}, {
  path: '/cookies-policy',
  name: 'Cookies Policy',
  priority: '0.3',
  freq: 'yearly'
}];
function buildXML() {
  const today = new Date().toISOString().split('T')[0];
  let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
  xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
  pages.forEach(p => {
    xml += '  <url>\n';
    xml += '    <loc>' + SITE_URL + p.path + '</loc>\n';
    xml += '    <lastmod>' + today + '</lastmod>\n';
    xml += '    <changefreq>' + p.freq + '</changefreq>\n';
    xml += '    <priority>' + p.priority + '</priority>\n';
    xml += '  </url>\n';
  });
  xml += '</urlset>';
  return xml;
}
export function SitemapPage() {
  usePageSEO({
    title: 'Sitemap | Design Flow Digitals',
    description: 'Sitemap for Design Flow Digitals website.'
  });
  const [copied, setCopied] = useState(false);
  const xmlContent = buildXML();
  const handleCopy = () => {
    navigator.clipboard.writeText(xmlContent).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return <div className="pt-32 pb-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-887">
      <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" data-id="element-888">
        Sitemap
      </h1>
      <p className="text-gray-400 mb-12 pb-8 border-b border-white/10" data-id="element-889">
        All pages on designflowdigitals.com
      </p>

      <div className="mb-16" data-id="element-890">
        <h2 className="text-2xl font-bold text-white mb-8" data-id="element-891">Pages</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-892">
          {pages.map(page => <a key={page.path} href={page.path} className="glass-card p-4 border-white/10 hover:border-[#D4AF37]/30 transition-colors duration-300 flex items-center justify-between group" data-id="element-893">
              <div data-id="element-894">
                <p className="text-white font-medium group-hover:text-[#D4AF37] transition-colors" data-id="element-895">
                  {page.name}
                </p>
                <p className="text-gray-500 text-sm mt-1" data-id="element-896">
                  {SITE_URL}
                  {page.path}
                </p>
              </div>
              <span className="text-gray-600 text-xs uppercase tracking-wider" data-id="element-897">
                {page.freq}
              </span>
            </a>)}
        </div>
      </div>

      <div data-id="element-898">
        <div className="flex items-center justify-between mb-4" data-id="element-899">
          <h2 className="text-2xl font-bold text-white" data-id="element-900">XML Sitemap</h2>
          <button onClick={handleCopy} className="px-4 py-2 text-sm font-medium bg-gradient-gold text-black rounded-lg hover:opacity-90 transition-opacity" data-id="element-901">
            {copied ? 'Copied!' : 'Copy XML'}
          </button>
        </div>
        <p className="text-gray-400 text-sm mb-6" data-id="element-902">
          Copy this XML and upload it as{' '}
          <code className="text-[#D4AF37]" data-id="element-903">sitemap.xml</code> to your hosting
          root, or submit it directly to Google Search Console.
        </p>
        <pre className="glass-card p-6 border-white/10 overflow-x-auto text-sm text-gray-300 leading-relaxed whitespace-pre-wrap break-all" data-id="element-904">
          {xmlContent}
        </pre>
      </div>
    </div>;
}